import { render, staticRenderFns } from "./Contact.vue?vue&type=template&id=7203ef2c&lang=pug&"
import script from "./Contact.vue?vue&type=script&lang=js&"
export * from "./Contact.vue?vue&type=script&lang=js&"
import style0 from "./Contact.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7203ef2c')) {
      api.createRecord('7203ef2c', component.options)
    } else {
      api.reload('7203ef2c', component.options)
    }
    module.hot.accept("./Contact.vue?vue&type=template&id=7203ef2c&lang=pug&", function () {
      api.rerender('7203ef2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Contact.vue"
export default component.exports